import * as React from "react";
const SvgFiRrFeedback = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-feedback_svg__a)">
      <path
        fill="#062147"
        d="M8.97 10.322a.5.5 0 0 1-.148.554l-1.183.964.489 1.49a.5.5 0 0 1-.169.553.5.5 0 0 1-.578.023l-1.377-.897-1.354.906a.5.5 0 0 1-.755-.566l.47-1.508-1.189-.967a.5.5 0 0 1 .323-.881h1.5l.531-1.49a.5.5 0 0 1 .938 0l.531 1.49h1.5a.5.5 0 0 1 .47.329zm5.53-.329H13l-.531-1.49a.5.5 0 0 0-.938 0L11 9.993H9.5a.499.499 0 0 0-.323.881l1.189.967-.47 1.508a.5.5 0 0 0 .755.566l1.354-.906 1.377.897a.5.5 0 0 0 .747-.576l-.489-1.49 1.183-.964a.5.5 0 0 0-.322-.883zm6 0H19l-.531-1.49a.5.5 0 0 0-.938 0L17 9.993h-1.5a.499.499 0 0 0-.323.881l1.189.967-.47 1.508a.5.5 0 0 0 .755.566l1.354-.906 1.377.897a.5.5 0 0 0 .747-.576l-.489-1.49 1.183-.964a.5.5 0 0 0-.323-.883M24 6.999v8c0 2.206-1.794 4-4 4h-2.852l-3.848 3.18a1.94 1.94 0 0 1-1.292.484 2 2 0 0 1-1.337-.507l-3.749-3.157H3.999c-2.206 0-4-1.794-4-4V7A4.006 4.006 0 0 1 4 3h16c2.206 0 4 1.793 4 3.999m-2 0c0-1.103-.897-2-2-2H4c-1.103 0-2 .897-2 2v8c0 1.103.897 2 2 2h3.288c.235 0 .464.083.645.235l4.048 3.41 4.171-3.416a1 1 0 0 1 .637-.229h3.212c1.103 0 2-.897 2-2V7z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-feedback_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrFeedback;
